import React, { useState } from 'react';
import '../../Admin/styles/main.scss';
import applogo from "../../User/assets/logo.svg";
import Grid from "@mui/material/Grid2";
import { Accordion, AccordionDetails, AccordionSummary, List, ListItem } from '@mui/material';
import { Link, useLocation, Outlet } from "react-router-dom";
import dashboard_icon from '../../Admin/assets/icons/dashboard.svg';
import catalogue_icon from '../../Admin/assets/icons/catalogue.svg';
import products_icon from '../../Admin/assets/icons/products.svg';
import orders_icon from '../../Admin/assets/icons/orders.svg';
import delivers_icon from '../../Admin/assets/icons/delivers.svg';
import banners_icon from '../../Admin/assets/icons/banners.svg';
import users_icon from '../../Admin/assets/icons/users.svg';
import employees_icon from '../../Admin/assets/icons/employees-icon.svg';
import suborders_icon from '../../Admin/assets/icons/suborder.svg';
import settings_icon from '../../Admin/assets/icons/settings.svg';
import consultation_icon from '../../Admin/assets/icons/constultation.svg';
import payment_icon from '../../Admin/assets/icons/payments.svg';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Sidebar = () => {
    const location = useLocation();
    //destructuring pathname from location
    const { pathname } = location;
    //Javascript split method to get the name of the path in array
    const splitLocation = pathname.split("/");
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');

    const [expandedAccordion, setExpandedAccordion] = useState(null);

    const handleAccordionToggle = (panel) => {
        setExpandedAccordion(expandedAccordion === panel ? null : panel);
    };

    const handleMenuClick = () => {
        setExpandedAccordion(null); // Close all accordions when a menu is clicked
    };
    return (
        <section className='main-section'>
            <Grid container>
                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 2 }}>
                    <div className='sidebar-content'>
                        <div className='sidebar-logo'>
                            <img src={applogo} alt="applogo" />
                        </div>
                        <List className="sidebar-list">
                            <Link to="/admin/dashboard" onClick={handleMenuClick}>
                                <ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "dashboard" ? "active" : ""}>
                                    <img src={dashboard_icon} alt='dashboard icon' />
                                    <span>Dashboard</span>
                                </ListItem>
                            </Link>
                            <Link to="/admin/consultation" onClick={handleMenuClick}>
                                <ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "consultation" ? "active" : ""}>
                                    <img src={consultation_icon} alt='orders_icon' />
                                    <span>Consultations</span>
                                </ListItem>
                            </Link>
                            {token && (role === 'Admin' || role === 'SeniorDesigner') &&
                                <Link to="/admin/orders" onClick={handleMenuClick}>
                                    <ListItem className={(splitLocation[1] === "admin" && splitLocation[2] === "orders") || (splitLocation[1] === "admin" && splitLocation[2] === "orderinfo") ? "active" : ""}>
                                        <img src={orders_icon} alt='orders_icon' />
                                        <span>Orders</span>
                                    </ListItem>
                                </Link>}
                            {token && (role === 'JuniorDesigner') &&
                                <Link to="/admin/suborders" onClick={handleMenuClick}>
                                    <ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "suborders" ? "active" : ""}>
                                        <img src={suborders_icon} alt='suborders_icon' />
                                        <span>Orders</span>
                                    </ListItem>
                                </Link>
                            }

                            {token && (role === 'Admin' || role === 'SeniorDesigner') &&
                                <Accordion
                                    expanded={expandedAccordion === 'catalogue'}
                                    onChange={() => handleAccordionToggle('catalogue')}
                                    className={
                                        splitLocation[2] === "category" ||
                                            splitLocation[2] === "subcategory" ||
                                            splitLocation[2] === "designtype" ||
                                            splitLocation[2] === "design"
                                            ? "active1"
                                            : ""
                                    }
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1-content"
                                        id="panel1-header"
                                    > <img src={catalogue_icon} alt='catalogue_icon' />
                                        <span> Catalogue</span>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className='accordion-details'>
                                            <List>
                                                <Link to="/admin/category"><ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "category" ? "active" : ""}>Category</ListItem></Link>
                                                <Link to="/admin/subcategory"><ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "subcategory" ? "active" : ""}>SubCategory</ListItem></Link>
                                                <Link to="/admin/designtype"><ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "designtype" ? "active" : ""}>Design type</ListItem></Link>
                                                <Link to="/admin/design"><ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "design" ? "active" : ""}>Design</ListItem></Link>
                                            </List>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>}

                            {/* <Link to="/admin/payments" onClick={handleMenuClick}>
                                <ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "payments" ? "active" : ""}>
                                    <img src={payment_icon} alt='payment_icon' />
                                    <span>Payments</span>
                                </ListItem>
                            </Link> */}

                            {/* <Link to="/admin/delivers" onClick={handleMenuClick}>
                                <ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "delivers" ? "active" : ""}>
                                    <img src={delivers_icon} alt='delivers_icon' />
                                    <span>Delivers</span>
                                </ListItem>
                            </Link> */}
                            {/* {token && role === 'JuniorDesigner' &&
                            <Link to="/admin/orderassign" onClick={handleMenuClick}>
                                <ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "orderassign" ? "active" : ""}>
                                    <img src={delivers_icon} alt='delivers_icon' />
                                    <span>Order Assign</span>
                                </ListItem>
                            </Link>} */}

                            <Link to="/admin/users" onClick={handleMenuClick}>
                                <ListItem className={(splitLocation[1] === "admin" && splitLocation[2] === "users") || (splitLocation[1] === "admin" && splitLocation[2] === "addtocart") || (splitLocation[1] === "admin" && splitLocation[2] === "ordereduser") ? "active" : ""}>
                                    <img src={users_icon} alt='users_icon' />
                                    <span>Users</span>
                                </ListItem>
                            </Link>
                            {token && role === 'Admin' &&
                                <Link to="/admin/banners">
                                    <ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "banners" ? "active" : ""}>
                                        <img src={banners_icon} alt='banners_icon' />
                                        <span>Banners</span>
                                    </ListItem>
                                </Link>}
                            {token && role === 'Admin' &&
                                <Link to="/admin/Notifications">
                                    <ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "Notifications" ? "active" : ""}>
                                        <img src={banners_icon} alt='banners_icon' />
                                        <span>Notifications</span>
                                    </ListItem>
                                </Link>}


                            {token && role === 'Admin' &&
                                <Link to="/admin/employees">
                                    <ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "employees" ? "active" : ""}>
                                        <img src={employees_icon} alt='notifications_icon' />
                                        <span>Employees</span>
                                    </ListItem>
                                </Link>
                            }
                            {token && (role === 'Admin' || role === 'SeniorDesigner') &&
                                <Link to="/admin/staff">
                                    <ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "staff" ? "active" : ""}>
                                        <img src={employees_icon} alt='notifications_icon' />
                                        <span>Staff</span>
                                    </ListItem>
                                </Link>
                            }
                            {/* <div className='help-section'> */}
                            {/* <Link to="/admin/support">
                                    <ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "support" ? "active" : ""}>
                                        <img src={help_icon} alt='help_icon' />
                                        <span>Support</span>
                                    </ListItem>
                                </Link> */}
                            {token && role === 'Admin' &&
                                <Link to="/admin/Reports">
                                    <ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "Reports" ? "active" : ""}>
                                        <img src={settings_icon} alt='Reports_icon' />
                                        <span>Reports</span>
                                    </ListItem>
                                </Link>
                            }
                            <Link to="/admin/settings">
                                <ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "settings" ? "active" : ""}>
                                    <img src={settings_icon} alt='settings_icon' />
                                    <span>Settings</span>
                                </ListItem>
                            </Link>
                            {token && role === 'Admin' &&
                                <Link to="/admin/Access">
                                    <ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "Accesspages" ? "active" : ""}>
                                        <img src={employees_icon} alt='notifications_icon' />
                                        <span>Access</span>
                                    </ListItem>
                                </Link>
                            }
                            {/* </div> */}

                        </List>
                    </div>
                </Grid >
                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 10 }} >
                    <Outlet />
                </Grid>
            </Grid >
        </section >
    )
}

export default Sidebar